import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const useUserStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoggedIn: false,

      login: async (email, password) => {
        try {
          const response = await axios.post(`${API}/login`, { email, password });
          const data = response.data;
          
          set({
            user: {
              email: data.email,
              name: data.name,
              loyalty_points: data.loyalty_points,
              total_spent: data.total_spent,
              has_first_order_discount: data.has_first_order_discount,
              discount_code: data.discount_code
            },
            token: data.access_token,
            isLoggedIn: true
          });
          
          return { success: true, data };
        } catch (error) {
          return { 
            success: false, 
            error: error.response?.data?.detail || 'Login failed' 
          };
        }
      },

      register: async (name, email, password, deviceFingerprint = null) => {
        try {
          const response = await axios.post(`${API}/register`, { 
            name, 
            email, 
            password,
            device_fingerprint: deviceFingerprint
          });
          const data = response.data;
          
          set({
            user: {
              email: email,
              name: name,
              loyalty_points: 0,
              total_spent: 0,
              has_first_order_discount: !data.fingerprint_blocked,
              discount_code: data.discount_code
            },
            token: data.access_token,
            isLoggedIn: true
          });
          
          return { success: true, data };
        } catch (error) {
          return { 
            success: false, 
            error: error.response?.data?.detail || 'Registration failed' 
          };
        }
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isLoggedIn: false
        });
      },

      refreshProfile: async () => {
        const { user, isLoggedIn } = get();
        if (!isLoggedIn || !user?.email) return;
        
        try {
          const response = await axios.get(`${API}/user/profile/${user.email}`);
          set({
            user: {
              ...user,
              loyalty_points: response.data.loyalty_points,
              total_spent: response.data.total_spent,
              can_redeem: response.data.can_redeem,
              next_reward_points: response.data.next_reward_points
            }
          });
        } catch (error) {
          console.error('Error refreshing profile:', error);
        }
      },

      getPointsInfo: () => {
        const { user } = get();
        if (!user) return { points: 0, canRedeem: false, nextReward: 100 };
        
        const points = user.loyalty_points || 0;
        return {
          points,
          canRedeem: points >= 100,
          redemptionValue: points >= 100 ? 5.00 : 0,
          nextReward: 100 - (points % 100),
          pointsPerDollar: 2
        };
      }
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token, 
        isLoggedIn: state.isLoggedIn 
      })
    }
  )
);

export default useUserStore;
